export enum AlertLevel {
  Information = 0,
  Warning = 1,
  Alert = 2,
}
